(function () {
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;

    // Trigger when button is in the middle-ish of screen
    var topBound = vh * 0.78;
    var bottomBound = vh * 0.20;

    return r.top < topBound && r.bottom > bottomBound;
  }

  function pulse(el) {
    el.classList.remove("yrl-glow");
    // force reflow so animation restarts
    void el.offsetWidth;
    el.classList.add("yrl-glow");

    clearTimeout(el.__yrlGlowT);
    el.__yrlGlowT = setTimeout(function () {
      el.classList.remove("yrl-glow");
    }, 1250);
  }

  var ticking = false;
  function onScroll() {
    if (!isMobile()) return;

    if (ticking) return;
    ticking = true;

    requestAnimationFrame(function () {
      ticking = false;

      var btns = document.querySelectorAll("a.yrl-cta, button.yrl-cta");
      if (!btns.length) return;

      btns.forEach(function (b) {
        if (inView(b)) pulse(b);
      });
    });
  }

  function init() {
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    // Shopify live editor / dynamic sections
    document.addEventListener("shopify:section:load", onScroll);
    document.addEventListener("shopify:section:reorder", onScroll);

    // Safety runs
    setTimeout(onScroll, 400);
    window.addEventListener("load", function () {
      setTimeout(onScroll, 400);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
